import {
    addDoc,
    getDocs,
    collection,
    doc,
    updateDoc,
    getCountFromServer,
    query
} from 'firebase/firestore'
import { db } from '../firebase'
export default class Coupon {
    constructor() {
        this.KEY = 'Coupon'
    }
    async allCoupons() {
        let data = []
        try {
            const querySnapshot = await getDocs(collection(db, this.KEY));

            querySnapshot.forEach((doc) => {
                // console.log(doc.id, " => ", doc.data());
                data.push({ ...doc.data(), id: doc.id })
            });
            return data
        } catch (error) {
            console.log(error);
            return []
        }
    }
    async addCoupon(params) {
        try {
            if (params.id) {
                const { id, ...prms } = params
                const docRef = doc(db, this.KEY, id)
                return await updateDoc(docRef, prms)
            }
            const coll = collection(db, this.KEY);
            const snapshot = await (await getCountFromServer(query(coll))).data().count;
            return await (await addDoc(collection(db, this.KEY), { ...params, id: snapshot })).id
        } catch (error) {
            console.error(error, params);
        }
    }
}